import { forwardRef, type TextareaHTMLAttributes } from "react";
import { classNames } from "../../classNames";
import { Icon, type IconName } from "../../icons";
import { useFieldControl } from "../Field/FieldContext";
import { InlineLabel } from "../TextInput/InlineLabel";

export interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  icon?: IconName;
  invalid?: boolean;
  /** Name shown inside the box, above the text, and kept while typing. */
  inlineLabel?: string;
}

/** Multi-line text box with the same optional icon and inline label as {@link TextInput}. */
export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(function TextArea(
  { icon, invalid, inlineLabel, className, id, ...rest },
  ref,
) {
  const control = useFieldControl({ id, invalid, inlineLabel, describedBy: rest["aria-describedby"] });
  return (
    <div className={classNames("nb-input-wrap", "is-multiline", inlineLabel ? "has-label" : null)}>
      {icon ? <Icon name={icon} className="nb-input-icon" /> : null}
      <InlineLabel text={inlineLabel} htmlFor={control.id} />
      <textarea ref={ref} className={classNames("nb-textarea", className)} {...control} {...rest} />
    </div>
  );
});
